import { DistrictNcesDetail, JobPosting } from "@nimble/candidate-api/types";

import JobDetailsHeaderContent from "@/components/shared/jobs/job-details/job-details-header-content";
import SchoolDetailSalaryScheduleLink from "@/components/shared/school/school-details/school-detail-salary-schedule-link";
import { MISSING_SCHOOL_NCES_ID } from "@/lib/constants/jobs.constants";
import { districtJobDetailsTestIds } from "@/lib/data-test-ids/districts.data-test-ids";

interface DistrictJobDetailsHeaderProps {
  jobPosting: JobPosting;
  district: DistrictNcesDetail;
  jobHref: string;
}

export default function DistrictJobDetailsHeader({
  jobPosting,
  district,
  jobHref,
}: DistrictJobDetailsHeaderProps) {
  return (
    <div className="relative border-b border-border pb-6">
      <div className="flex flex-row items-start sm:justify-between gap-4">
        <JobDetailsHeaderContent
          jobPosting={jobPosting}
          titleHref={jobHref}
          eyebrow={
            <p
              className="text-sm font-medium text-ink-subtle"
              data-testid={
                districtJobDetailsTestIds.DISTRICT_JOB_HEADER_DISTRICT_NAME
              }
            >
              {district.name}
            </p>
          }
        >
          {district.salary_schedule_link && (
            <SchoolDetailSalaryScheduleLink
              salaryScheduleLink={district.salary_schedule_link}
              schoolId={MISSING_SCHOOL_NCES_ID}
            />
          )}
        </JobDetailsHeaderContent>
      </div>
    </div>
  );
}
